import { authors } from "./readcubeMap"
import meta from "@readcube/rcp-meta/type_schema.json"
import { defaultTypeNameFromMapping } from "@readcube/rcp-meta"
import { CommonOptions, formatAuthor, onFile } from "../common"
import { format } from "./format"
import { parseISO, isValid, format as dateFormat } from "date-fns"
import _get from "lodash/get"

const DEFAULT_BASE_APP_URL = "https://app.readcube.com"
const DEFAULT_BASE_WEB_URL = "https://www.readcube.com"

export const asRis = ({ item, newLine, mapping, baseAppUrl, baseWebUrl }: CommonOptions & { baseAppUrl?: string, baseWebUrl?: string }) => {

  baseAppUrl = baseAppUrl ?? DEFAULT_BASE_APP_URL
  baseWebUrl = baseWebUrl ?? DEFAULT_BASE_WEB_URL

  let out = getMetadata(item, mapping || meta)

  out.push(["UR", baseAppUrl + `/library/${item.collection_id}/item/${item.id}`])
  if (item.files?.length)
    out.push(["PF", baseWebUrl + `/library/${item.collection_id}:${item.id}`])

  out = removeEmpty(out)
  addEndRecord(out)

  const tyIndex = out.findIndex(pair => pair[0] === "TY")
  if (tyIndex !== -1) {
    const [ty] = out.splice(tyIndex, 1)
    out.unshift(ty)
  }

  return format(out, newLine)
}

const addEndRecord = (out: any) => out.push(["ER", ""])

const removeEmpty = (out: any) => out.filter((entry: any) => entry[1] && entry[1] !== "")

const getMetadata = (item: any, mapping: any) => {

  const defaultTypeName = defaultTypeNameFromMapping(mapping)

  const type =
    item.custom_type
      || item.item_type
      || defaultTypeName

  console.log({ type })

  let typeFields = mapping.types[type]?.fields
  if (!typeFields)
    typeFields = mapping.types[defaultTypeName]?.fields

  if (!typeFields)
    throw new Error("I can't figure out the type fields for type:" + type)

  let out: any[] = typeFields
    .map((field: any) => mapping.field_defs[field])
    .filter((fieldDef: any) => fieldDef && fieldDef.ris)
    .reduce((risFields: any[], fieldDef: any) => {
      const { ris } = fieldDef
      const value = _get(
        item,
        fieldDef.readcube || `custom_metadata.${fieldDef.custom_metadata}`,
      )

      if (ris.includes(",")) {
        const risAliases = ris.split(",")
        risAliases.forEach((r: any) => risFields.push([r, value]))
      } else if (ris === "AU" && value) {
        risFields = [...risFields, ...value.map((v: any) => [ris, formatAuthor(v)])]
      } else if (ris === "KW" && value) {
        risFields = [...risFields, ...value.map((v: any) => [ris, v])]
      } else {
        risFields.push([ris, value])
      }

      return risFields
    }, [])

  out.unshift(["TY", mapping.types[type] && mapping.types[type].ris_type])

  if (!out.find(entry => entry[0] === "AU"))
    out = [ ...authors(item), ...out ]

  const daEntry = out.find(entry => entry[0] === "DA")
  if (daEntry) {
    const date = parseISO(daEntry[1])
    if (isValid(date))
      daEntry[1] = dateFormat(date, "yyyy/MM/dd")
  }

  const yearEntry = out.find(entry => entry[0] === "PY")
  if (item.article.year && (!yearEntry || !yearEntry[1]))
    out.push(["PY", item.article.year])

  onFile(item, p => { out.push(["L1", p]) })
  return out
}
